import SectionDivider from "./common/SectionDivider";
import {Address} from "./Address";
import {useTranslation} from "react-i18next";

export const ContactSection = () => {
    const { t } = useTranslation();
    return (
        <div className="bg-primary-light-color">
            <div className="section">
                <h1 data-aos="fade-right"
                    data-aos-duration="300"
                    className="text-primary-dark-color">{t('contact_header')}</h1>
                <SectionDivider/>
                <div className="max-w-screen-md">{t('contact_subtitle')}</div>
                <Address/>
            </div>
        </div>
    );
}
